import React from 'react';
import Image from 'next/image';
import EPLogo from 'images/brand-assets/EnergyPal-Logo-E-blue.png';
import { YEAR } from 'lib/constants';
// import { YEAR } from 'lib/constants';

type Props = {
  date: string;
};

const AuthorBlock = ({ date }: Props) => {
  return (
    <div>
      {' '}
      <div className="flex items-center space-x-4 pt-0">
        <div className="w-[49px] bg-gray-200  h-[48px] rounded-full flex justify-center items-center">
          <Image
            src={EPLogo}
            width={48}
            height={48}
            alt="Author"
            className="rounded-full"
          />
        </div>
        <div>
          <p className="font-semibold m-0 text-black text-base">
            Last updated: {date}, {YEAR}
          </p>
          <p className="text-sm font-semibold text-gray-700 p-0 m-0">
            EnergyPal Team
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthorBlock;
